export default __webpack_public_path__ + "static/sidekick-mobile-d38e3ec859b71402a36d06fbeaf8243b.svg";